import { RgbColor, RgbColorPicker } from "react-colorful";
import { useState, useMemo } from "react";
import { RiCheckLine, RiEraserFill, RiPaletteFill } from "react-icons/ri";

const colorShortCuts = [
    'rgb(0, 0, 0)',
    'rgb(77, 77, 77)',
    'rgb(153, 153, 153)',
    'rgb(230, 230, 230)',
    'rgb(255, 255, 255)',
    'rgb(230, 77, 77)',
    'rgb(230, 153, 77)',
    'rgb(230, 230, 77)',
    'rgb(153, 230, 77)',
    'rgb(77, 230, 77)',
    'rgb(77, 230, 153)',
    'rgb(77, 230, 230)',
    'rgb(77, 153, 230)',
    'rgb(77, 77, 230)',
    'rgb(153, 77, 230)',
]

export function parseRgb(rgbString: string) {
    // Remove extra whitespace and convert to lowercase
    const normalized = rgbString.trim().toLowerCase();

    // Match rgb() or rgba() format with either commas or spaces
    const match = normalized.match(/rgba?\((\d+)[,\s]+(\d+)[,\s]+(\d+)(?:[,\s/]+[\d.]+)?\)/);

    if (!match) {
        throw new Error('Invalid RGB string format. Expected format: "rgb(r, g, b)", "rgb(r g b)", "rgba(r, g, b, a)", or "rgba(r g b / a)"');
    }

    return {
        r: parseInt(match[1], 10),
        g: parseInt(match[2], 10),
        b: parseInt(match[3], 10)
    };
}

export function rgbToStr(color: RgbColor) {
    return `rgb(${color.r} ${color.g} ${color.b})`
}

function areEqualShallow(a: object, b: object) {
    for (var key in a) {
        if (a[key] !== b[key]) {
            return false;
        }
    }
    return true;
}

export default function ColorPicker(props: { currentColor: string, close: () => void, applyColor: (color: string | null) => void }) {
    const currentRgb = useMemo(() => parseRgb(props.currentColor), [props.currentColor]);
    const [tempFontColor, setTempFontColor] = useState(currentRgb);
    const tempFontColorStr = useMemo(() => rgbToStr(tempFontColor), [tempFontColor]);
    const [showPicker, setShowPicker] = useState(false);
    if (showPicker) {
        return <>
            <RgbColorPicker color={currentRgb} onChange={setTempFontColor} />
            <button className="color-picker-button"
                onClick={() => { props.applyColor(tempFontColorStr); props.close() }}>
                Apply <span style={{ backgroundColor: tempFontColorStr }} class="color-picker-color-indicator"></span>
            </button>
            <button
                className="color-picker-button cancel"
                onClick={() => { props.close() }}>
                Cancel
            </button>
        </>
    } else {
        return <div className="color-picker-shortcut-container">
            <button onClick={() => { props.applyColor(null) }}><RiEraserFill />Remove Color</button>
            {colorShortCuts.map((color) => {
                return <span className={`color-picker-shortcut ${color == "rgb(0, 0, 0)" ? "white-active" : ""}`} onClick={() => { props.applyColor(color) }} style={{ backgroundColor: color }}>
                    {areEqualShallow(currentRgb, parseRgb(color)) && <RiCheckLine />}
                </span>
            })}
            <button onClick={(e) => { e.stopPropagation(); setShowPicker(!showPicker) }}><RiPaletteFill />Color Picker</button>
        </div>
    }

}